import { styled } from "@mui/material/styles";

// Components
import { Typography } from "@mui/material";

// Themes
import theme from "~/components/Common/Theme";

const styledName = "FormErrorMessage";

export const StyledErrorMessage = styled(Typography, { name: styledName })({
  "&": {
    color: theme.palette.error.main,
    opacity: 0,
    width: "100%",
    maxHeight: 0,
    height: "auto",
    transform: "scaleY(0)",
    textAlign: "start",
    animation: `height-grow 0.3s ease-in forwards`,
  },
});
